import { z } from "zod";
import { isoDateTimeString, uuidSchema } from "./common";

export const raterRoleSchema = z.enum([
  "WORKER_RATES_EMPLOYER",
  "EMPLOYER_RATES_WORKER",
]);

export const ratingSchema = z.object({
  id: uuidSchema,
  postingId: uuidSchema,
  raterUserId: uuidSchema,
  rateeUserId: uuidSchema,
  raterRole: raterRoleSchema,
  raterDisplayName: z.string().nullable(),
  raterAvatarUrl: z.string().nullable().optional(),
  score: z.number().int().min(1).max(5),
  comment: z.string().nullable().optional(),
  hiddenByAdmin: z.boolean(),
  createdAt: isoDateTimeString,
});

export const submitRatingRequestSchema = z.object({
  score: z.number().int().min(1).max(5),
  comment: z.string().max(1000).optional(),
});

export const ratingListResponseSchema = z.object({
  items: z.array(ratingSchema),
  nextCursor: z.string().nullable(),
  aggregate: z.object({
    avg: z.number().min(0).max(5).nullable(),
    count: z.number().int().min(0),
    distribution: z.object({
      1: z.number().int().min(0),
      2: z.number().int().min(0),
      3: z.number().int().min(0),
      4: z.number().int().min(0),
      5: z.number().int().min(0),
    }),
  }),
});

export const adminHideRatingRequestSchema = z.object({
  reason: z.string().min(1).max(500),
});

export type RaterRole = z.infer<typeof raterRoleSchema>;
export type Rating = z.infer<typeof ratingSchema>;
export type SubmitRatingRequest = z.infer<typeof submitRatingRequestSchema>;
export type RatingListResponse = z.infer<typeof ratingListResponseSchema>;
export type AdminHideRatingRequest = z.infer<
  typeof adminHideRatingRequestSchema
>;
